  // You can write your custom Javascript here
  jQuery(document).ready(function () {
    // Shop Pay Installments Handling
    function initShopPayInstallments() {
      jQuery('.shop-pay-installments').each(function() {
        var $banner = jQuery(this);
        var variantPrice = parseInt($banner.data('variant-price')) || 0;
        var currency = '$'; // Default to $ since you removed currency data attribute
        
        // Show banner only for eligible amounts ($50-$3000 USD equivalent)
        var priceInDollars = variantPrice / 100;
        
        if (priceInDollars >= 50 && priceInDollars <= 3000) {
          var installmentAmount = (priceInDollars / 4).toFixed(2);
          
          // Update the installment amount display
          $banner.find('.installments-amount').text(currency + installmentAmount);
          
          // Show the banner
          $banner.show();
          
          // Add click handler for learn more - ensure we're targeting the right element
          $banner.find('.installments-learn-more').off('click').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Learn more clicked'); // Debug log
            showInstallmentsModal(priceInDollars, installmentAmount, currency);
          });
        } else {
          // Hide banner for ineligible amounts
          $banner.hide();
        }
      });
    }
    
    // Show installments information modal
    function showInstallmentsModal(totalPrice, installmentAmount, currency) {
      var modalHtml = `
        <div class="installments-modal-overlay">
          <div class="installments-modal">
            <div class="installments-modal-header">
              <h3>Shop Pay Installments</h3>
              <button class="installments-modal-close">&times;</button>
            </div>
            <div class="installments-modal-body">
              <p><strong>Pay ${currency}${totalPrice.toFixed(2)} in 4 interest-free payments of ${currency}${installmentAmount}</strong></p>
              <ul>
                <li>No interest or fees when you pay on time</li>
                <li>Payments every 2 weeks</li>
                <li>Available for orders $50-$3,000</li>
                <li>Must have a Shop Pay account</li>
              </ul>
              <p><small>Subject to eligibility. Complete terms at checkout.</small></p>
            </div>
          </div>
        </div>
      `;
      
      jQuery('body').append(modalHtml);
      
      // Close modal handlers
      jQuery('.installments-modal-overlay').on('click', function(e) {
        if (e.target === this) {
          jQuery(this).remove();
        }
      });
      
      jQuery('.installments-modal-close').on('click', function() {
        jQuery('.installments-modal-overlay').remove();
      });
      
      // Close on escape key
      jQuery(document).on('keydown.installments', function(e) {
        if (e.keyCode === 27) {
          jQuery('.installments-modal-overlay').remove();
          jQuery(document).off('keydown.installments');
        }
      });
    }
    
    // Update installments when variant changes
    jQuery(document).on('change', 'select[name="id"], input[name="id"]', function() {
      var variantId = jQuery(this).val();
      var $option = jQuery(this).find('option[value="' + variantId + '"]');
      
      if ($option.length && $option.data('price')) {
        jQuery('.shop-pay-installments').attr('data-variant-price', $option.data('price'));
        initShopPayInstallments();
      }
    });
    
    // Listen for variant changes from other sources
    jQuery(document).on('variant:change', function(event, variant) {
      if (variant && variant.price) {
        jQuery('.shop-pay-installments').attr('data-variant-price', variant.price);
        initShopPayInstallments();
      }
    });
    
    // Initialize on page load
    initShopPayInstallments();
    
    // jQuery('.radio.radio--color.disabled').parent().remove();

  // Wedding Date - Required
  if (!jQuery("#field-date").val()) {
    if ($('body').hasClass('template-cart')) {
      jQuery("#field-date").parent().find(".error").slideDown();
      jQuery("#field-date").closest('.form__row').find(".wedding-label").addClass('date-error');
    }
  }
  // Check if error came from checkout
  if (window.location.hash === "#wedding-date") {
    if (!jQuery("#field-date").val()) {
      jQuery(".btn--checkout").attr("disabled", true);
      jQuery(".wedding-date-picker").find(".error").slideDown();
      jQuery(".wedding-date-picker").find(".wedding-label").addClass('date-error');
      jQuery(".wedding-date-picker").addClass('wedding__error');
      document.querySelector(".wedding-date-picker").scrollIntoView({
        behavior: "smooth",
      });
      setTimeout(function () {
        jQuery("#field-date").trigger("blur").trigger("focus");
      }, 1000);
    }
  }
  jQuery("#field-date").on("change", function (e) {
    if (e.target.value) {
      jQuery(".btn--checkout").attr("disabled", false);
      jQuery(e.target).parent().find(".error").slideUp();
      jQuery(e.target).closest('.form__row').find(".wedding-label").removeClass('date-error');
      jQuery(".wedding__controls").removeClass('wedding__error');
      // Came from checkout, focus on button after selection
      if (window.location.hash === "#wedding-date") {
        setTimeout(function () {
          jQuery(".btn--checkout").trigger("focus");
        }, 1000);
      }
    } else {
      jQuery(".btn--checkout").attr("disabled", true);
      jQuery(e.target).parent().find(".error").slideDown();
      jQuery(e.target).closest('.form__row').find(".wedding-label").addClass('date-error');
      jQuery("#field-date").trigger("blur").trigger("focus");
      jQuery(".wedding__controls").addClass('wedding__error');
    }
  });

  $(".em-wdgt-products").each(function (elmnt) {
    $(this).html('<img src="//cdn.shopify.com/s/files/1/0300/7401/t/180/assets/bc-sf-filter-loading.gif" />');
    render_products($(this));
  });

  function render_products(elmnt) {
    let widget = $(elmnt);
    let handle = widget.data("collection");
    let color = lower_case(widget.data("color"));
    let limit = widget.data("size");
    $.get("https://www.kennedyblue.com/collections/" + handle + "/products.json", function (data) {
      let products = data.products;
      let html_data = '<div class="products-grid">';
      for (var i = 0; i < products.length; i++) {
        if (i >= limit) {
          break;
        }
        html_data += get_product_data(products[i], color);
      }
      html_data += '</div>';
      widget.html(html_data);
    });
  }

  function get_product_data(product, color) {
    let variants = product['variants'];
    let variant = variants[0];
    if (color != null && color != undefined) {
      for (var i = 0; i < variants.length; i++) {
        if (lower_case(variants[i]['option1']) == color || lower_case(variants[i]['option2']) == color || lower_case(variants[i]['option3']) == color) {
          variant = variants[i];
          break;
        }
      }
    }
    let product_url = "/products/" + product["handle"] + "?variant=" + variant["id"];
    return '<div class="product-grid"><div class="product-item-inner"><div class="product-item-image"><a href="' + product_url + '"><img src="' + variant['featured_image']['src'] + '" /></a></div><div class="product-bottom"><a href="' + product_url + '" class="product-item-title">' + product['title'] + '</a><p class="product-item-price"><span class="product-item-regular-price">$&nbsp;' + variant['price'] + '</span></p></div></div></div>';
  }

  function lower_case(str) {
    if (str == null || str == undefined) {
      return str;
    }

    return str.toString().toLowerCase();
  }
});

$(document).on('click', '[name="checkout"]', function (e) {
  if (!$("#field-date").val()) {
    e.preventDefault();
    $(this).attr("disabled", true);
    $(this).closest('form').find(".error").slideDown();
    $(this).closest('form').find(".wedding-label").addClass('date-error');
    $("#field-date").trigger("blur").trigger("focus");
    $(".wedding__controls").addClass('wedding__error');
  }
});


if (document.querySelector('.nav .nav__dropdown .nav__dropdown')) {
  document.querySelectorAll('.nav .nav__dropdown .nav__dropdown').forEach(el => {
    if (jQuery(window).width() >= 768) {
      let cont = el.closest('.shell').querySelector('.dropdown-menu');
      let contH = jQuery(cont).outerHeight(true);
      let titleH = jQuery(cont.querySelector('.dropdown-menu-title')).outerHeight(true);
      let linkH = jQuery(el.closest('.nav__item').querySelector('a')).outerHeight(true);
      el.style.marginTop = "-" + (titleH + linkH - 18) + "px";
      el.style.minHeight = contH + "px";
    }
  });
}

if (document.querySelector('.nav .nav__dropdown .nav__dropdown')) {
  document.querySelectorAll('.nav .nav__dropdown .nav__dropdown').forEach(el => {
    if (jQuery(window).width() < 768) {
      let links = el.closest('.nav__item').querySelectorAll('&> a');
      if(links.length > 0) {
        links.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            //link.classList.toggle('is-active');
            showNavDropdownsForMobile(link)
          });
        });
      }
    }
  });
}

if(typeof showNavDropdownsForMobile == "undefined") {
  function showNavDropdownsForMobile($clickedElement) {
    let mobileWidth = 767;
    $clickedElement = jQuery($clickedElement);
    if (jQuery(window).width() > mobileWidth) {
      $clickedElement.parent().addClass('is-active').siblings().removeClass('is-active');
    } else {
      if(!$clickedElement.hasClass('is-active')) {
        $clickedElement.addClass('is-active').next('.nav__dropdown').slideDown().closest('li').siblings().find('.is-active').removeClass('is-active').next('.nav__dropdown').slideUp();
      }
      else {
        $clickedElement.removeClass('is-active').next('.nav__dropdown').slideUp().closest('li').siblings().find('.is-active').removeClass('is-active').next('.nav__dropdown').slideUp();
      }
    }
  }
}


if(typeof genFx == "undefined") {
  function genFx( type, includeWidth ) {
    var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
    var which,
      i = 0,
      attrs = { height: type };

    // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for ( ; i < 4; i += 2 - includeWidth ) {
      which = cssExpand[ i ];
      attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
    }

    if ( includeWidth ) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }
}

// Generate shortcuts for custom animations
jQuery.each( {
  slideDown: genFx( "show" ),
  slideUp: genFx( "hide" ),
  slideToggle: genFx( "toggle" ),
  fadeIn: { opacity: "show" },
  fadeOut: { opacity: "hide" },
  fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
  jQuery.fn[ name ] = function( speed, easing, callback ) {
    return this.animate( props, speed, easing, callback );
  };
} );